function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { trackEvent } from "services/bigbrain-service";
import { TAB_CLICKED } from "constants/bigbrain-event-types";
import Carousel from "../carousel/carousel";
import { StyledMobileTabs } from "./mobile-tabs.scss";
const VISIBILITY_SENSOR_OFFSET = -100;
const CAROUSEL_LEFT_SWIPE = "left";
const CAROUSEL_RIGHT_SWIPE = "right";
const MobileTabs = (props)=>{
    const [carouselRef, setCarouselRef] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const itemsRef = useRef([]);
    const { tabs, selectedTab, setSelectedTab, navigationItemRenderer, carouselItemRenderer, wasComponentEverVisible, setWasComponentEverVisible } = props;
    const onVisibilityChange = (isVisibleValue)=>{
        if (!wasComponentEverVisible && isVisibleValue) {
            setWasComponentEverVisible(true);
            if (selectedTab !== 0) {
                var _itemsRef_current_selectedTab, _itemsRef_current;
                itemsRef === null || itemsRef === void 0 ? void 0 : (_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : (_itemsRef_current_selectedTab = _itemsRef_current[selectedTab]) === null || _itemsRef_current_selectedTab === void 0 ? void 0 : _itemsRef_current_selectedTab.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center"
                });
            }
        }
        setIsVisible(isVisibleValue);
    };
    const tabsWithVideoPlayerRefs = [];
    tabs.forEach((tab)=>{
        tabsWithVideoPlayerRefs.push(_object_spread_props(_object_spread({}, tab), {
            videoPlayerRef: useRef(null)
        }));
    });
    useEffect(()=>{
        itemsRef.current = itemsRef.current.slice(0, tabsWithVideoPlayerRefs.length);
    }, [
        tabsWithVideoPlayerRefs
    ]);
    const onTabClicked = (element, tab, index)=>{
        setSelectedTab(index);
        element.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
        trackEvent(TAB_CLICKED, {
            kind: tab.tabLabel,
            info1: index
        });
    };
    useEffect(()=>{
        var _currentTab_videoPlayerRef;
        const currentTab = tabsWithVideoPlayerRefs[selectedTab];
        if (currentTab === null || currentTab === void 0 ? void 0 : (_currentTab_videoPlayerRef = currentTab.videoPlayerRef) === null || _currentTab_videoPlayerRef === void 0 ? void 0 : _currentTab_videoPlayerRef.current) {
            currentTab.videoPlayerRef.current.seekTo(0);
        }
        carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.slickGoTo(selectedTab);
    }, [
        selectedTab
    ]);
    const scrollToNavigationTabIfVisible = (index)=>{
        if (isVisible) {
            var _itemsRef_current_index, _itemsRef_current;
            itemsRef === null || itemsRef === void 0 ? void 0 : (_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : (_itemsRef_current_index = _itemsRef_current[index]) === null || _itemsRef_current_index === void 0 ? void 0 : _itemsRef_current_index.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    };
    const navItemRenderer = (tab, index)=>{
        const isSelectedTab = selectedTab === index;
        return /*#__PURE__*/ _jsx("div", {
            className: "tab-nav-button-wrapper",
            ref: (element)=>itemsRef.current[index] = element,
            onClick: (event)=>onTabClicked(event.target, tab, index),
            children: navigationItemRenderer(tab, index, isSelectedTab)
        }, index);
    };
    const carouselProps = {
        items: tabsWithVideoPlayerRefs,
        itemRenderer: carouselItemRenderer,
        defaultIndex: wasComponentEverVisible ? 0 : selectedTab,
        slidesToShow: 1,
        autoplay: false,
        autoplaySpeed: -1,
        centerPadding: "5%",
        centerMode: false,
        infinite: false,
        fade: false,
        onRefSet: setCarouselRef
    };
    const onCarouselChange = (current)=>{
        // fix selectedTab index in case of a glitch
        if (current !== selectedTab) {
            setSelectedTab(current);
            scrollToNavigationTabIfVisible(current);
        }
    };
    const onCarouselSwipe = (direction)=>{
        let newSlide = selectedTab;
        if (direction === CAROUSEL_LEFT_SWIPE && selectedTab < tabs.length - 1) {
            newSlide = selectedTab + 1;
        }
        if (direction === CAROUSEL_RIGHT_SWIPE && selectedTab > 0) {
            newSlide = selectedTab - 1;
        }
        setSelectedTab(newSlide);
        scrollToNavigationTabIfVisible(selectedTab);
    };
    return /*#__PURE__*/ _jsx(VisibilitySensor, {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ _jsxs(StyledMobileTabs, {
            className: "mobile-tabs-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "mobile-tabs-navigation",
                    children: tabsWithVideoPlayerRefs.map((tab, index)=>navItemRenderer(tab, index))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "carousel-wrapper",
                    children: /*#__PURE__*/ _jsx(Carousel, _object_spread_props(_object_spread({}, carouselProps), {
                        onChange: (current)=>onCarouselChange(current),
                        onSwipe: onCarouselSwipe
                    }))
                })
            ]
        })
    });
};
export default MobileTabs;
